
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import {Button} from 'reactstrap';
import SelectionView from '../../../../../components/selectionView/SelectionView'
import RefundDialogue from '../../refund/RefundDialogue'

var commonUtility = require('../../../../../utils/domain/commonUtility');
var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var saleCalculator = require('../../../../../utils/domain/sales/saleCalculator');
var staffAccessUtility = require('../../../../../utils/domain/staff/staffAccessUtility');
var staffUtility = require('../../../../../utils/domain/staff/staffUtility');
var staffActivities = require('../../../../../utils/domain/staff/staffActivities');
var viewUtil = require('../../../../../utils/view/viewUtil');
var saleContextUtil = require('../../../utils/saleContextUtil');
var constants = require('../../../../../utils/domain/constants');
var creditCardProcessor = require('../../../../../utils/creditCardProcessor/creditCardProcessor');
var salePrinter = require('../../../utils/salePrinter');

const translator = require('../../../../../utils/translator/translator');

class CancelToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.renderCancellationsDialogueOptions = this.renderCancellationsDialogueOptions.bind(this);
        this.renderRefundDialogue = this.renderRefundDialogue.bind(this);
        
        this.state = {};
        this.state.showRefundDialogue = false;
        this.state.refundCode = null;
        this.state.showCancellationsOptionsDialogue = false;
    }

    render()
    {
        return (<Fragment>
                    <Button disabled={!saleCommonUtility.canCancelSale(this.props.saleContext.sale)} onClick={this.onCancel} className='btn-action' style={{minHeight:'8vh', minWidth:'33.33%', borderRadius: 0}}>
                            {translator.getLabel("cancel")}
                    </Button>
                    {this.renderCancellationsDialogueOptions()}
                    {this.renderRefundDialogue()}
                </Fragment>)
    }

    onCancel()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if  (
                !saleCommonUtility.isExistingSale(saleContext) &&
                (!saleCalculator.isSalePartiallyOrFullyPaid(sale) || sale.paymentMethod == constants.PaymentMethodVenuePaid)
            )
        {
            saleContextUtil.closeSale();
            return;
        }

        viewUtil.showLoginDialogue(staff =>
            {
                if (!staffAccessUtility.canStaffPerformActivity(staff, staffActivities.canCancelAnOrder))
                {
                    viewUtil.showErrorAlert(translator.getLabel("you_do_not_have_sufficient_privileges_to_cancel_an_order"));
                    return;
                }
                
                this.state.showCancellationsOptionsDialogue = true;
                this.setState({});
            });

        
    }

    renderCancellationsDialogueOptions()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if (!this.state.showCancellationsOptionsDialogue)
            return null;

        let selections = [];

        let selection = {};
        selection.caption = translator.getLabel("missing_items");
        selection.id = translator.getLabel("missing_items");
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("late_order");
        selection.id = translator.getLabel("late_order");
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("customer_did_not_collect");
        selection.id = translator.getLabel("customer_did_not_collect");
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("not_cooked_properly");
        selection.id = translator.getLabel("not_cooked_properly");
        selections.push(selection);

        selection = {};
        selection.caption = translator.getLabel("wrong_order");
        selection.id = translator.getLabel("wrong_order");
        selections.push(selection);

        return <SelectionView selections={selections} caption={translator.getLabel("cancellation_reasons")}
                                onClose={()=>
                                {
                                    this.state.showCancellationsOptionsDialogue = false;
                                    this.setState({});
                                }}
                                onSelection={(selection)=>
                                {
                                    this.state.showCancellationsOptionsDialogue = false;
                                    this.setState({});

                                    
                                    if (!saleCalculator.isSalePartiallyOrFullyPaid(sale))
                                    {
                                        sale.isCancelled = true;
                                        sale.cancellationReason = selection.id;
                                        sale.cancelledBy = staffUtility.getLoginStaffCompleteName();
                                        saleContextUtil.raiseSaleContextSaleChangeEvent(false);
                                        saleContextUtil.publishAndCloseSale(saleContext);
                                        return;
                                    }

                                    if (sale.paymentMethod == constants.PaymentMethodVenuePaid && !creditCardProcessor.canHandleRefund(sale))
                                    {
                                        if (saleContext.isExistingSale)
                                        {
                                            var refund = {};
                                            refund.refundCode = selection.id;
                                            refund.refundReason = selection.id;
                                            refund.refundAmount = sale.paidAmount;
                                            refund.operator = staffUtility.getLoginStaffCompleteName()
                                            sale.refunds.push(refund);

                                            sale.isCancelled = true;
                                            sale.cancellationReason = selection.id;

                                            saleContextUtil.raiseSaleContextSaleChangeEvent(false);
                                            saleContextUtil.publishAndCloseSale(saleContext);
                                            return;
                                        }

                                        saleContextUtil.closeSale();
                                        return;
                                    }

                                    var error = this.verifySelectedRowsForRefund();
                                    if (error != null)
                                    {
                                        viewUtil.showErrorAlert(error);
                                        return;
                                    }

                                    this.state.refundCode = selection.id;
                                    this.state.showRefundDialogue = true;
                                    this.setState({});

                                }}
                />
    }

    renderRefundDialogue()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if (!this.state.showRefundDialogue)
            return null;

        let partialRefundableAmount = this.calculatePartialRefundAmount();
        let originalRefundedAmount = saleCalculator.calculateTotalRefunds(sale);

        return <RefundDialogue
                    sale={sale}
                    refundCode={this.state.refundCode}
                    refundStaff={staffUtility.getLoginStaff()}
                    partialRefundableAmount = {partialRefundableAmount}
                    onClose={async (paymentModified) =>
                    {
                        if (paymentModified)
                        {
                            let newRefunds = saleCalculator.calculateTotalRefunds(sale) - originalRefundedAmount;
                            if (partialRefundableAmount != null)
                            {
                                let stillRefundable = partialRefundableAmount - newRefunds;
                                if (stillRefundable <= constants.numericThresholdValue)
                                {
                                    for (var index = 0; index < this.props.saleContext.selectedItems.length; index++)
                                    {
                                        var selectedItem = this.props.saleContext.selectedItems[index];
                                        saleCommonUtility.markItemAsRefunded(selectedItem, this.state.refundDialogueCode);
                                    }
                                }
                            }

                            saleContext.selectedItems = [];
                            saleContextUtil.prepareSaleForPublishing(saleContext);
                            saleContextUtil.raiseSaleContextSaleChangeEvent(false, true, true);

                            if (newRefunds > constants.numericThresholdValue && await this.isReceiptPrintingRequired())
                            {
                                await salePrinter.printSaleCustomerReceipt(sale, commonUtility.getPropertyPrintConfiguration().noOfReceiptPrints);
                            }

                            if (saleCalculator.isSaleFullyRefunded(sale))
                            {
                                saleContextUtil.publishAndCloseSale(saleContext);
                                return;
                            }
                        }

                        this.state.showRefundDialogue = false;
                        this.state.refundDialogueCode = null;
                        this.state.refundDialogueStaff = null;
                        this.setState({});
                    }} />;
    }

    verifySelectedRowsForRefund()
    {
        if (this.props.saleContext.selectedItems == null || this.props.saleContext.selectedItems.length <= 0)
            return null;

        for (var index = 0; index < this.props.saleContext.selectedItems.length; index++)
        {
            var selectedItem = this.props.saleContext.selectedItems[index];
            if (selectedItem.isRefunded)
                return `Sale item ${selectedItem.caption} is already refunded`;
        }
    }

    calculatePartialRefundAmount()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if (saleCalculator.calculateTotalRefundableAmount(sale) <= constants.numericThresholdValue)
            return null;

        var partialRefundAmount = 0;
        for (var index = 0; index < this.props.saleContext.selectedItems.length; index++)
        {
            var selectedItem = this.props.saleContext.selectedItems[index];
            partialRefundAmount = partialRefundAmount + saleCalculator.calculateRefundsPriceForItem(selectedItem);;
        }

        if (partialRefundAmount <= constants.numericThresholdValue ||
            partialRefundAmount > saleCalculator.calculateTotalRefundableAmount(sale))
            return null;

        return partialRefundAmount;
    }

    isReceiptPrintingRequired()
    {
        const isReceiptPrintingOptional = commonUtility.getPropertyPrintConfiguration().receiptPrintingOptional;

        if (isReceiptPrintingOptional == false) return true;

        return new Promise((resolve, reject) =>
        {
            viewUtil.showPrompt(
                "Print Receipt",
                "Do you wish to print receipt ?", null,
                () => resolve(true),        // onConfirm
                () => resolve(false));      // onDeny
        });
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(CancelToolbarButton)
